import { httpService } from "./httpService";

/**
 * In-app admin notifications (bell dropdown). Tenant-scoped broadcast in v1.
 */

export const getNotifications = async () =>
  httpService({ url: "/notifications", options: { method: "GET" } });

export const getUnreadNotificationCount = async () =>
  httpService({ url: "/notifications/unread-count", options: { method: "GET" } });

export const markNotificationRead = async (id) =>
  httpService({ url: `/notifications/${id}/read`, options: { method: "POST" } });

export const markAllNotificationsRead = async () =>
  httpService({ url: "/notifications/read-all", options: { method: "POST" } });
